import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import CasePage from "./pages/CasePage";
import DashboardPage from "./pages/DashboardPage";
import LandingPage from "./pages/LandingPage";
import LicencaDeUsoPage from "./pages/LicencaDeUsoPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RegularizacaoPage from "./pages/RegularizacaoPage";
import TermosDeUsoPage from "./pages/TermosDeUsoPage";
import "./App.css";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center">
        <div className="text-[#0F4C5C] font-serif text-xl">Carregando...</div>
      </div>
    );
  }
  return user ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center">
        <div className="text-[#0F4C5C] font-serif text-xl">Carregando...</div>
      </div>
    );
  }
  return user ? <Navigate to="/dashboard" /> : children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
          <Route path="/case/:id" element={<PrivateRoute><CasePage /></PrivateRoute>} />
          <Route path="/regularizacao" element={<PrivateRoute><RegularizacaoPage /></PrivateRoute>} />
          <Route path="/licenca-de-uso" element={<PrivateRoute><LicencaDeUsoPage /></PrivateRoute>} />
          <Route path="/termos-de-uso" element={<TermosDeUsoPage />} />
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
